import React from 'react';

import VisibleIcon from 'icons/ic-visible-16.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import Checkbox from 'components/application/Checkbox';

import { formatDate } from 'components/helpers/dates';
import { resourceShape } from 'components/helpers/serialisableResources';

export default function MasterCoshhRow({
  isAddedToProject,
  masterCoshhDocument,
  onAdd,
  onDelete,
  onEdit,
  onSdsPreviewClick,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  const handleTick = () => {
    isAddedToProject ?
      onDelete(masterCoshhDocument)
    : onAdd(masterCoshhDocument);
  };

  const handleSdsPreviewClick = () => {
    onSdsPreviewClick(masterCoshhDocument);
  };

  return (
    <tr className='handshq__tr--taller'>
      <td className='tw-border-grey-100'>
        <Checkbox
          isChecked={isAddedToProject}
          label={i18nTCommon('projects.coshh.addCoshh')}
          name='select-coshh'
          onChange={handleTick}
        />
      </td>
      <td className='tw-border-grey-100 tw-py-1 tw-text-grey-900'>
        <div className='tw-flex tw-h-10 tw-items-center'>
          <span className='truncated-text-container--wrapped truncated-text-container--two-lines'>
            {masterCoshhDocument.attributes.title}
          </span>
        </div>
      </td>
      <td className='tw-border-grey-100 tw-py-1'>
        <div className='tw-flex tw-h-10 tw-items-center'>
          <span className='truncated-text-container--wrapped truncated-text-container--two-lines'>
            {masterCoshhDocument.attributes.manufacturer}
          </span>
        </div>
      </td>
      <td className='tw-border-grey-100'>
        <div className='tw-flex tw-h-8 tw-items-center'>
          {masterCoshhDocument.attributes.reference}
        </div>
      </td>
      <td className='tw-border-grey-100'>
        <div className='tw-flex tw-h-8 tw-items-center'>
          {formatDate({
            date: masterCoshhDocument.attributes.revisionDate,
            format: 'd MMM yyyy',
          })}
        </div>
      </td>
      <td className='tw-border-grey-100 has-[[data-element-name=sds-preview]:hover]:tw-bg-blue-025'>
        <div className='tw-flex tw-h-8 tw-items-center'>
          {masterCoshhDocument.attributes.attachedUrl && (
            <div
              className='tw-flex tw-cursor-pointer tw-items-center'
              data-element-name='sds-preview'
              onClick={handleSdsPreviewClick}
            >
              <VisibleIcon className='tw-mr-1' />
              <span>{i18nTCommon('projects.coshh.sds')}</span>
            </div>
          )}
        </div>
      </td>
      <td className='handshq__td-button-cell--align-right tw-border-grey-100'>
        <div className='tw-flex tw-items-center tw-justify-end'>
          {isAddedToProject && (
            <div className='tw-flex tw-h-8 tw-w-30.5'>
              <OutlinedButton
                className='tw-mr-2 tw-h-full tw-w-full tw-justify-center'
                color='grey'
                onClick={() => onEdit(masterCoshhDocument)}
              >
                {i18nTCommon('shared.edit')}
              </OutlinedButton>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}

MasterCoshhRow.propTypes = {
  isAddedToProject: PropTypes.bool.isRequired,
  masterCoshhDocument: resourceShape('masterCoshhDocument').isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSdsPreviewClick: PropTypes.func.isRequired,
};
